function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M464,288h-32H304c-8.832,0-16,7.168-16,16v64c0,44.128,35.872,80,80,80c38.656,0,70.944-27.52,78.368-64H464 c26.464,0,48-21.536,48-48S490.464,288,464,288z M464,352h-16v-32h16c8.8,0,16,7.2,16,16S472.8,352,464,352z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M368,256c8.832,0,16-7.168,16-16v-16h48c8.832,0,16-7.168,16-16v-48h48c8.832,0,16-7.168,16-16V80 c0-44.096-35.872-80-80-80H16C7.168,0,0,7.168,0,16v480c0,8.832,7.168,16,16,16h480c8.832,0,16-7.168,16-16v-32 c0-8.832-7.168-16-16-16H368H192V160h96v48c0,8.832,7.168,16,16,16h48v16C352,248.832,359.168,256,368,256z M400.32,64h0.32 c8.832,0,16,7.168,16,16c0,8.832-7.168,16-16,16c-8.8,0-16.16-7.168-16.16-16C384.48,71.168,391.456,64,400.32,64z M112,352H80 c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h32c8.832,0,16,7.168,16,16C128,344.832,120.832,352,112,352z M112,288H80 c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h32c8.832,0,16,7.168,16,16C128,280.832,120.832,288,112,288z M112,224H80 c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h32c8.832,0,16,7.168,16,16C128,216.832,120.832,224,112,224z M336.64,96 c-8.8,0-16.16-7.168-16.16-16c0-8.832,6.976-16,15.84-16h0.32c8.832,0,16,7.168,16,16C352.64,88.832,345.472,96,336.64,96z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function Svg71(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg71);
export default __webpack_public_path__ + "static/media/7_1.b3e37e09.svg";
export { ForwardRef as ReactComponent };